import _ from 'lodash';

export default function selector(storeState, props) {
    return {};
}
